import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const gestaoCandidatosRoutes: Routes = [
  {
    path: 'gestao-candidatos',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Gestão de Candidatos',
      breadcrumb: [{ label: 'Gestão de Candidatos', url: '/gestao-candidatos' }],
    },
    children: [
      {
        path: 'distribuicao',
        loadComponent: () =>
          import('./distribuicao.component').then((m) => m.DistribuicaoComponent),
        data: {
          title: 'Distribuição de Candidatos',
          roles: [
            Role.DISTRIBUICAO_CONSULTAR,
            Role.DISTRIBUICAO_EDITAR,
            Role.DISTRIBUICAO_DISTRIBUIR_AUTOMATICO,
            Role.DISTRIBUICAO_DISTRIBUIR_MANUAL,
            Role.DISTRIBUICAO_LIMPAR,
            Role.DISTRIBUICAO_ATIVAR_TECNICO,
            Role.DISTRIBUICAO_DESATIVAR_TECNICO,
            Role.DISTRIBUICAO_RELATORIO
          ],
          breadcrumb: [
            { label: 'Distribuição de Candidatos', url: '/gestao-candidatos/distribuicao' },
          ],
        },
      },
    ],
  },
];
